import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import {exhaustMap, take} from 'rxjs/operators';
import {LoginService} from './login.service';
import {Observable} from 'rxjs';
import {isPlatformBrowser} from "@angular/common";

@Injectable()
export class LoginInterceptorService implements HttpInterceptor {
  private loginService = inject(LoginService);
  private platformId = inject<Object>(PLATFORM_ID);


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return this.loginService.getAuthData().pipe(
      take(1),
      exhaustMap(user => {
        let modifiedReq = req.clone();
        if (isPlatformBrowser(this.platformId)) {
          modifiedReq = req.clone({
            headers: req.headers.set('X-WEBABO-PROFILEKEY', vHost.id),
          });
        }
        if ( user?.token) {
          const tokenReq = modifiedReq.clone({
            headers: modifiedReq.headers.append('X-WEBABO-SSOTOKEN', user.token)
              .append('Cache-Control', 'no-cache, no-store, must-revalidate')
              .append('Pragma', 'no-cache')
              .append('Expires', 'Sat, 01 Jan 2000 00:00:00 GMT')
              .append('If-Modified-Since', '0'),
          });
          return next.handle(tokenReq);
        } else {
          return next.handle(modifiedReq);
        }
      })
    );
  }
}
